import { lazy } from 'react';

// Switchboard — canonical fifth destination; existing Settings components are
// preserved behind its Configure lens.
export const SwitchboardPage = lazy(() => import('@/app/navigation/pages/switchboard/SwitchboardPage'));
